import { LocalAuthority } from '@modules/local-authorities/interfaces';
import { createAction, props } from '@ngrx/store';

// load local authorities
export const LOAD_LOCAL_AUTHORITIES = '[Local Authorities] Load Local Authorities';
export const LOAD_LOCAL_AUTHORITIES_FAIL = '[Local Authorities] Load Local Authorities Fail';
export const LOAD_LOCAL_AUTHORITIES_SUCCESS = '[Local Authorities] Load Local Authorities Success';

export const LoadLocalAuthorities = createAction(LOAD_LOCAL_AUTHORITIES, props<{ payload: string }>());

export const LoadLocalAuthoritiesFail = createAction(LOAD_LOCAL_AUTHORITIES_FAIL, props<{ payload: Error }>());

export const LoadLocalAuthoritiesSuccess = createAction(
    LOAD_LOCAL_AUTHORITIES_SUCCESS,
    props<{ payload: LocalAuthority[] }>()
);

// action types
export type LocalAuthoritiesAction =
    | typeof LoadLocalAuthorities
    | typeof LoadLocalAuthoritiesFail
    | typeof LoadLocalAuthoritiesSuccess;
